import { $getRoot, $createParagraphNode, $isParagraphNode } from "lexical";
import { $isHeadingNode } from "@lexical/rich-text";
import { $isListNode } from "@lexical/list";
import { $createPageNode, $isPageNode } from "../nodes/PageNode.jsx";

/** Keeps the document valid: >= 1 page, a typing line after every page's last block. */
export function $ensureStructure() {
  const root = $getRoot();
  if (root.getChildrenSize() === 0) root.append($createPageNode());

  root.getChildren().forEach((child) => {
    if (!$isPageNode(child)) {
      const page = $createPageNode();
      child.insertBefore(page);
      page.append(child);
    }
  });

  root.getChildren().forEach((page) => {
    if (page.getChildrenSize() === 0) page.append($createParagraphNode());
    const last = page.getLastChild();
    if (
      last &&
      !($isParagraphNode(last) || $isHeadingNode(last) || $isListNode(last))
    ) {
      page.append($createParagraphNode());
    }
  });
}
